import moment from "moment";
import { useDrag } from "react-dnd";
import { AiFillDelete } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useDeleteProjectMutation } from "../../features/project/projectApi";

export default function ProjectCard({ project }) {
    // project search text
    const { search } = useSelector((state) => state.project);
    const { color, creator, description, id, name, position, teamId, date } =
        project || {};
    const { avatar } = creator || {};

    // user info
    const { user } = useSelector((state) => state.auth);
    //delete api
    const [deleteProjectApi] = useDeleteProjectMutation();

    const [{ isDragging, opacity }, drag] = useDrag({
        type: "PROJECT_STAGE_CHANGE",
        item: { id },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        }),
    });

    // delete project
    const deleteProject = () => {
        deleteProjectApi(id);
    };

    // search project
    const isMatched = description.toLowerCase().includes(search.toLowerCase());

    // delete button componet

    const deleteComponent = (
        <>
            <button
                disabled={creator.email !== user?.email}
                onClick={deleteProject}
                className="absolute top-0 right-0 items-center justify-center hidden w-6 hover:bg-red-200 hover:text-red-600 h-5 mt-3 mr-2 text-gray-500 rounded  group-hover:flex"
            >
                <AiFillDelete />
            </button>
        </>
    );

    return (
        <>
            <div
                ref={drag}
                className={`relative flex flex-col  items-start p-4 mt-3 bg-white rounded-lg cursor-pointer bg-opacity-90 group hover:bg-opacity-100 ${
                    search !== "" &&
                    isMatched &&
                    "border-2 border-green-600 shadow-lg"
                }`}
                draggable="true"
                style={{ opacity }}
            >
                {position === "backlog" &&
                    creator.email === user?.email &&
                    deleteComponent}
                {position === "backlog" && creator.email !== user?.email && (
                    <p className="absolute bg-red-50 text-xs text-red-600 shadow-lg w-[50%] p-2 top-0 right-0 items-center justify-center hidden mt-3 mr-2 rounded  group-hover:flex">
                        Project creator can delete it!
                    </p>
                )}

                <span
                    style={{
                        backgroundColor: color,
                        color: "white",
                    }}
                    className="flex items-center h-6 px-3 text-xs font-semibold rounded-full"
                >
                    {name}
                </span>
                <h4 className="mt-3 text-sm font-medium">{description}</h4>
                <div className="flex items-center w-full mt-3 text-xs font-medium text-gray-400">
                    <div className="flex items-center">
                        <svg
                            className="w-4 h-4 text-gray-300 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                clipRule="evenodd"
                            />
                        </svg>
                        <span className="ml-1 leading-none">
                            {moment(date).format("MMMM D")}
                        </span>
                    </div>

                    <img
                        className="w-6 h-6 ml-auto rounded-full"
                        src={avatar}
                    />
                </div>
            </div>
        </>
    );
}
